@if (items?.length) { @for (item of items; track trackByFunction ?
trackByFunction(item) : item) {
<ng-container
  *epcDynamicComponentIf="{
    operation: item.if,
    instance: this
  }"
>
  <ng-template
    [epcDynamicComponent]="{
      contentTypeId: item.contentTypeId,
      parent: parent ?? this
    }"
    [id]="item.id"
    [isRoot]="isRoot"
    [scope]="scope"
    [inputs]="item.inputs"
    [styles]="item.styles"
    [children]="item.children"
    [data]="item.data"
    [eventHandlers]="item.eventHandlers"
    [outputs]="item.outputs"
    [attributes]="item.attributes"
    [events]="item.events"
  ></ng-template>
</ng-container>
} }
